import React from 'react';
import PageHero from '../components/common/PageHero';
import Export from '../components/home/Export';
import ShipStoresSupply from '../components/home/ShipStoresSupply';

const ImportExport = () => {
  return (
    <div>
      <PageHero
        title="Import & Export"
        subtitle="Global trade lanes with rigorous quality controls and documentation you can trust."
      />
      <Export />
      <ShipStoresSupply />
    </div>
  );
};

export default ImportExport;